var Ge = Object.defineProperty, je = Object.defineProperties;
var Je = Object.getOwnPropertyDescriptors;
var V = Object.getOwnPropertySymbols;
var me = Object.prototype.hasOwnProperty, pe = Object.prototype.propertyIsEnumerable;
var we = (i) => {
  throw TypeError(i);
};
var G = (i, e, t) => e in i ? Ge(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, w = (i, e) => {
  for (var t in e || (e = {}))
    me.call(e, t) && G(i, t, e[t]);
  if (V)
    for (var t of V(e))
      pe.call(e, t) && G(i, t, e[t]);
  return i;
}, y = (i, e) => je(i, Je(e));
var j = (i, e) => {
  var t = {};
  for (var s in i)
    me.call(i, s) && e.indexOf(s) < 0 && (t[s] = i[s]);
  if (i != null && V)
    for (var s of V(i))
      e.indexOf(s) < 0 && pe.call(i, s) && (t[s] = i[s]);
  return t;
};
var a = (i, e, t) => G(i, typeof e != "symbol" ? e + "" : e, t), Se = (i, e, t) => e.has(i) || we("Cannot " + t);
var ye = (i, e, t) => (Se(i, e, "read from private field"), t ? t.call(i) : e.get(i)), be = (i, e, t) => e.has(i) ? we("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(i) : e.set(i, t), ke = (i, e, t, s) => (Se(i, e, "write to private field"), s ? s.call(i, t) : e.set(i, t), t);
var _ = (i, e, t) => new Promise((s, n) => {
  var o = (d) => {
    try {
      l(t.next(d));
    } catch (c) {
      n(c);
    }
  }, r = (d) => {
    try {
      l(t.throw(d));
    } catch (c) {
      n(c);
    }
  }, l = (d) => d.done ? s(d.value) : Promise.resolve(d.value).then(o, r);
  l((t = t.apply(i, e)).next());
});
import { W as Qe, M as C, r as J, I as ve, a as _e, S as Ye, C as Xe, F as Ze, b as et, P as tt, c as Re, g as st, p as it, d as nt, e as rt, f as ot, h as at, s as ct, i as lt } from "./record-BZHDLKsW.js";
import { R as ls } from "./record-BZHDLKsW.js";
import { s as K, G as O, g as F, S as E, r as De, a as Q, b as dt, c as ht, d as Y, e as X, f as W, F as Ie, V as gt, P as ut, h as ft, H as Z, M as mt, i as pt, L as We, j as ze, p as wt, k as Le, l as Ce, m as St, n as yt, o as bt, q as kt, t as vt, u as _t, v as Rt, w as Dt, x as It } from "./common-BjaGmQrE.js";
import { X as Lt, F as Ct, A as Et, C as Nt, E as Ot, s as Be, D as Tt, a as Pt, m as Ee, d as Me, b as Ne, c as Oe, r as Fe, e as Ht, p as Ut, f as Wt, g as zt, M as D, h as N, W as Bt, N as Mt, P as Ft, J as $t, i as x, j as A, k as Vt, l as xt, n as At, o as Te } from "./observe-D78YYNE1.js";
import { O as hs } from "./observe-D78YYNE1.js";
import { L as Kt, s as qt, a as T } from "./buffer-BjzLorpP.js";
import { g as Pe } from "./LDObserve-DhF3vCDR.js";
import { L as us } from "./LDObserve-DhF3vCDR.js";
import { LDRecord as ms } from "./LDRecord.js";
const Gt = (i, e, t) => {
  const s = window._highlightWebSocketRequestCallback;
  window._highlightWebSocketRequestCallback = i;
  const n = window._highlightWebSocketEventCallback;
  return window._highlightWebSocketEventCallback = (o) => {
    const h = o, { message: r, size: l } = h, d = j(h, ["message", "size"]), g = t.some(
      (f) => o.name.toLowerCase().includes(f)
    ) ? d : o;
    e(g);
  }, () => {
    window._highlightWebSocketRequestCallback = s, window._highlightWebSocketEventCallback = n;
  };
}, jt = ({
  xhrCallback: i,
  fetchCallback: e,
  webSocketRequestCallback: t,
  webSocketEventCallback: s,
  disableWebSocketRecording: n,
  bodyKeysToRedact: o,
  highlightEndpoints: r,
  tracingOrigins: l,
  urlBlocklist: d,
  bodyKeysToRecord: c
}) => {
  const g = Lt(
    i,
    r,
    l,
    d,
    o,
    c
  ), h = Ct(
    e,
    r,
    l,
    d,
    o,
    c
  ), f = n ? () => {
  } : Gt(
    t,
    s,
    d
  );
  return () => {
    g(), h(), f();
  };
};
class I {
  constructor(e) {
    a(this, "disableConsoleRecording");
    a(this, "reportConsoleErrors");
    a(this, "enablePromisePatch");
    a(this, "consoleMethodsToRecord");
    a(this, "listeners");
    a(this, "errors");
    a(this, "messages");
    // The properties below were added in 4.0.0 (Feb 2022), and are patched in by client via setupNetworkListeners()
    a(this, "options");
    a(this, "hasNetworkRecording", !0);
    a(this, "disableNetworkRecording");
    a(this, "enableRecordingNetworkContents");
    a(this, "xhrNetworkContents");
    a(this, "fetchNetworkContents");
    a(this, "disableRecordingWebSocketContents");
    a(this, "webSocketNetworkContents");
    a(this, "webSocketEventContents");
    a(this, "tracingOrigins");
    a(this, "networkHeadersToRedact");
    a(this, "networkBodyKeysToRedact");
    a(this, "networkBodyKeysToRecord");
    a(this, "networkHeaderKeysToRecord");
    a(this, "lastNetworkRequestTimestamp");
    a(this, "urlBlocklist");
    a(this, "highlightEndpoints");
    a(this, "requestResponseSanitizer");
    var t, s;
    this.options = e, this.disableConsoleRecording = !!e.disableConsoleRecording, this.reportConsoleErrors = (t = e.reportConsoleErrors) != null ? t : !1, this.enablePromisePatch = (s = e.enablePromisePatch) != null ? s : !1, this.consoleMethodsToRecord = e.consoleMethodsToRecord || [
      ...Et
    ], this.listeners = [], this.errors = [], this.messages = [], this.lastNetworkRequestTimestamp = 0;
  }
  isListening() {
    return this.listeners.length > 0;
  }
  startListening() {
    if (this.isListening()) return;
    const e = this;
    this.disableConsoleRecording || this.listeners.push(
      Nt(
        (t) => {
          var s, n, o;
          if (this.reportConsoleErrors && (t.type === "Error" || t.type === "error") && t.value && t.trace) {
            const r = K(t.value);
            if (Ne.includes(r) || Oe.some(
              (l) => r.includes(l)
            ))
              return;
            e.errors.push({
              event: r,
              type: "console.error",
              url: window.location.href,
              source: (s = t.trace[0]) != null && s.fileName ? t.trace[0].fileName : "",
              lineNumber: (n = t.trace[0]) != null && n.lineNumber ? t.trace[0].lineNumber : 0,
              columnNumber: (o = t.trace[0]) != null && o.columnNumber ? t.trace[0].columnNumber : 0,
              stackTrace: t.trace,
              timestamp: (/* @__PURE__ */ new Date()).toISOString(),
              id: Fe()
            });
          }
          e.messages.push(t);
        },
        y(w({}, Me), {
          level: this.consoleMethodsToRecord,
          recordLaunchDarklySdkLogs: this.options.recordLaunchDarklySdkLogs
        })
      )
    ), this.listeners.push(
      Ot(
        (t) => {
          Ne.includes(t.event) || Oe.some(
            (s) => t.event.includes(s)
          ) || e.errors.push(t);
        },
        { enablePromisePatch: this.enablePromisePatch }
      )
    ), this.listeners.push(Be), I.setupNetworkListener(this, this.options);
  }
  stopListening() {
    this.listeners.forEach((e) => e()), this.listeners = [];
  }
  // We define this as a static method because versions earlier than 4.0.0 (Feb 2022) don't have this code.
  // For those versions, calling this from client will monkey-patch the network listeners onto the old FirstLoadListener object.
  static setupNetworkListener(e, t) {
    var o, r, l, d, c, g, h, f, m, R, k, L;
    const s = (t == null ? void 0 : t.backendUrl) || void 0 || "https://pub.highlight.io", n = t.otlpEndpoint || "https://otel.highlight.io";
    e.highlightEndpoints = [
      s,
      `${n}/v1/traces`,
      `${n}/v1/logs`,
      `${n}/v1/metrics`
    ], e.xhrNetworkContents = [], e.fetchNetworkContents = [], e.webSocketNetworkContents = [], e.webSocketEventContents = [], e.networkHeadersToRedact = [], e.urlBlocklist = [], e.tracingOrigins = t.tracingOrigins || [], (t == null ? void 0 : t.disableNetworkRecording) !== void 0 ? (e.disableNetworkRecording = t == null ? void 0 : t.disableNetworkRecording, e.enableRecordingNetworkContents = !1, e.disableRecordingWebSocketContents = !0, e.networkHeadersToRedact = [], e.networkBodyKeysToRedact = [], e.urlBlocklist = [], e.networkBodyKeysToRecord = []) : typeof (t == null ? void 0 : t.networkRecording) == "boolean" ? (e.disableNetworkRecording = !t.networkRecording, e.enableRecordingNetworkContents = !1, e.disableRecordingWebSocketContents = !0, e.networkHeadersToRedact = [], e.networkBodyKeysToRedact = [], e.urlBlocklist = []) : (((o = t.networkRecording) == null ? void 0 : o.enabled) !== void 0 ? e.disableNetworkRecording = !t.networkRecording.enabled : e.disableNetworkRecording = !1, e.enableRecordingNetworkContents = ((r = t.networkRecording) == null ? void 0 : r.recordHeadersAndBody) || !1, e.disableRecordingWebSocketContents = ((l = t.networkRecording) == null ? void 0 : l.disableWebSocketEventRecordings) || !1, e.networkHeadersToRedact = ((c = (d = t.networkRecording) == null ? void 0 : d.networkHeadersToRedact) == null ? void 0 : c.map(
      (S) => S.toLowerCase()
    )) || [], e.networkBodyKeysToRedact = ((h = (g = t.networkRecording) == null ? void 0 : g.networkBodyKeysToRedact) == null ? void 0 : h.map(
      (S) => S.toLowerCase()
    )) || [], e.urlBlocklist = ((m = (f = t.networkRecording) == null ? void 0 : f.urlBlocklist) == null ? void 0 : m.map(
      (S) => S.toLowerCase()
    )) || [], e.urlBlocklist = [
      ...e.urlBlocklist,
      ...Tt
    ], e.requestResponseSanitizer = (R = t.networkRecording) == null ? void 0 : R.requestResponseSanitizer, e.networkHeaderKeysToRecord = (k = t.networkRecording) == null ? void 0 : k.headerKeysToRecord, e.networkHeaderKeysToRecord && (e.networkHeadersToRedact = [], e.networkHeaderKeysToRecord = e.networkHeaderKeysToRecord.map(
      (S) => S.toLocaleLowerCase()
    )), e.networkBodyKeysToRecord = (L = t.networkRecording) == null ? void 0 : L.bodyKeysToRecord, e.networkBodyKeysToRecord && (e.networkBodyKeysToRedact = [], e.networkBodyKeysToRecord = e.networkBodyKeysToRecord.map(
      (S) => S.toLocaleLowerCase()
    ))), !e.disableNetworkRecording && e.enableRecordingNetworkContents && (e.hasNetworkRecording = !0, e.listeners.push(
      jt({
        xhrCallback: (S) => {
          e.xhrNetworkContents.push(S);
        },
        fetchCallback: (S) => {
          e.fetchNetworkContents.push(S);
        },
        webSocketRequestCallback: (S) => {
          e.webSocketNetworkContents && e.webSocketNetworkContents.push(S);
        },
        webSocketEventCallback: (S) => {
          e.webSocketEventContents.push(S);
        },
        disableWebSocketRecording: e.disableRecordingWebSocketContents,
        bodyKeysToRedact: e.networkBodyKeysToRedact,
        highlightEndpoints: e.highlightEndpoints,
        tracingOrigins: e.tracingOrigins,
        urlBlocklist: e.urlBlocklist,
        bodyKeysToRecord: e.networkBodyKeysToRecord
      })
    ));
  }
  static getRecordedNetworkResources(e, t) {
    var o, r;
    let s = [], n = [];
    if (!e.disableNetworkRecording) {
      const l = ((o = window == null ? void 0 : window.performance) == null ? void 0 : o.timeOrigin) || 0;
      s = performance.getEntriesByType(
        "resource"
      );
      const d = (t - l) * 2;
      if (s = s.filter((c) => c.responseEnd < e.lastNetworkRequestTimestamp ? !1 : Pt(
        c.name,
        e.highlightEndpoints
      )).map((c) => y(w({}, c.toJSON()), {
        offsetStartTime: c.startTime - d,
        offsetResponseEnd: c.responseEnd - d,
        offsetFetchStart: c.fetchStart - d
      })), e.lastNetworkRequestTimestamp = ((r = s.at(-1)) == null ? void 0 : r.responseEnd) || e.lastNetworkRequestTimestamp, e.enableRecordingNetworkContents) {
        const c = {
          headersToRedact: e.networkHeadersToRedact,
          headersToRecord: e.networkHeaderKeysToRecord,
          requestResponseSanitizer: e.requestResponseSanitizer
        };
        s = Ee(
          s,
          e.xhrNetworkContents,
          "xmlhttprequest",
          c
        ), s = Ee(
          s,
          e.fetchNetworkContents,
          "fetch",
          c
        );
      }
    }
    return e.disableRecordingWebSocketContents || (n = e.webSocketNetworkContents || []), [...s, ...n];
  }
  static getRecordedWebSocketEvents(e) {
    let t = [];
    return !e.disableNetworkRecording && !e.disableRecordingWebSocketContents && (t = e.webSocketEventContents), t;
  }
  static clearRecordedNetworkResources(e) {
    e.disableNetworkRecording || (e.xhrNetworkContents = [], e.fetchNetworkContents = [], e.webSocketNetworkContents = [], e.webSocketEventContents = [], performance.clearResourceTimings());
  }
}
const z = (i, e) => {
  T("warn", `Highlight Warning: (${i}): `, { output: e });
};
var $;
const se = class se {
  constructor(e, t) {
    a(this, "options");
    /** Determines if the client is running on a Highlight property (e.g. frontend). */
    a(this, "isRunningOnHighlight");
    /** Verbose project ID that is exposed to users. Legacy users may still be using ints. */
    a(this, "organizationID");
    // ECMAScript-private (#) so the internal GraphQL SDK type — which
    // references graphql-request / graphql — does not leak into the published
    // declaration file and break consumer type-checking.
    be(this, $);
    a(this, "events");
    a(this, "sessionData");
    a(this, "ready");
    a(this, "manualStopped");
    a(this, "state");
    a(this, "logger");
    a(this, "enableSegmentIntegration");
    a(this, "privacySetting");
    a(this, "enableCanvasRecording");
    a(this, "enablePerformanceRecording");
    a(this, "samplingStrategy");
    a(this, "inlineImages");
    a(this, "inlineVideos");
    a(this, "inlineStylesheet");
    a(this, "styleSheetResyncInterval");
    a(this, "debugOptions");
    a(this, "listeners");
    a(this, "firstloadVersion");
    a(this, "environment");
    a(this, "sessionShortcut");
    /** The end-user's app version. This isn't Highlight's version. */
    a(this, "appVersion");
    a(this, "serviceName");
    a(this, "_worker");
    a(this, "_optionsInternal");
    a(this, "_backendUrl");
    a(this, "_recordingStartTime");
    a(this, "_isOnLocalHost");
    a(this, "_onToggleFeedbackFormVisibility");
    a(this, "_firstLoadListeners");
    a(this, "_isCrossOriginIframe");
    a(this, "_eventBytesSinceSnapshot");
    a(this, "_lastSnapshotTime");
    a(this, "_lastVisibilityChangeTime");
    a(this, "pushPayloadTimerId");
    a(this, "hasSessionUnloaded");
    a(this, "hasPushedData");
    a(this, "reloaded");
    a(this, "_hasPreviouslyInitialized");
    a(this, "_recordStop");
    a(this, "_gauges", /* @__PURE__ */ new Map());
    a(this, "_counters", /* @__PURE__ */ new Map());
    a(this, "_histograms", /* @__PURE__ */ new Map());
    a(this, "_up_down_counters", /* @__PURE__ */ new Map());
    a(this, "_integrations", []);
    var n, o, r, l, d;
    e.sessionSecureID || (e.sessionSecureID = O()), this.options = e, typeof ((n = this.options) == null ? void 0 : n.debug) == "boolean" ? this.debugOptions = this.options.debug ? { clientInteractions: !0 } : {} : this.debugOptions = (r = (o = this.options) == null ? void 0 : o.debug) != null ? r : {}, this.logger = new Kt(this.debugOptions.clientInteractions), e.debug && qt(!0), e.storageMode && (this.logger.log(
      `initializing in ${e.storageMode} session mode`
    ), St(e.storageMode)), ze(!!(e != null && e.sessionCookie)), this._worker = new Qe(), this._worker.onmessage = (c) => {
      var g, h, f;
      ((g = c.data.response) == null ? void 0 : g.type) === C.AsyncEvents ? (this._eventBytesSinceSnapshot += c.data.response.eventsSize, this.logger.log(
        `Web worker sent payloadID ${c.data.response.id} size ${c.data.response.eventsSize} bytes, compression ratio ${c.data.response.eventsSize / c.data.response.compressedSize}.
                Total since snapshot: ${(this._eventBytesSinceSnapshot / 1e6).toFixed(1)}MB`
      )) : ((h = c.data.response) == null ? void 0 : h.type) === C.CustomEvent ? this.addCustomEvent(
        c.data.response.tag,
        c.data.response.payload
      ) : ((f = c.data.response) == null ? void 0 : f.type) === C.Stop && (z(
        "Stopping recording due to worker failure",
        c.data.response
      ), this.stopRecording(!1));
    };
    let s = F();
    if (this.reloaded = !1, !((l = this.sessionData) != null && l.sessionSecureID) && (s != null && s.sessionSecureID))
      this.sessionData = s, this.options.sessionSecureID = s.sessionSecureID, this.reloaded = !0, this.logger.log(
        `Tab reloaded, continuing previous session: ${this.sessionData.sessionSecureID}`
      );
    else {
      for (const c of Object.values(E))
        De(c);
      this.sessionData = {
        sessionSecureID: this.options.sessionSecureID,
        projectID: 0,
        sessionStartTime: Date.now()
      };
    }
    this._hasPreviouslyInitialized = !1, this._firstLoadListeners = t || new I(this.options);
    try {
      window.parent.document && (this._isCrossOriginIframe = !1);
    } catch (c) {
      this._isCrossOriginIframe = (d = this.options.recordCrossOriginIframe) != null ? d : !0;
    }
    this._initMembers(this.options);
  }
  static create(e) {
    return new se(e);
  }
  // Start a new session
  _reset(s) {
    return _(this, arguments, function* ({
      forceNew: e,
      sessionKey: t
    }) {
      this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0);
      let n, o;
      if (!e)
        try {
          n = Q(E.USER_IDENTIFIER);
          const r = Q(
            E.USER_OBJECT
          );
          r && (o = JSON.parse(r));
        } catch (r) {
        }
      for (const r of Object.values(E))
        De(r);
      this.sessionData.sessionSecureID = t ? O(`${this.organizationID}-${t}`) : O(), this.sessionData.sessionKey = t, this.sessionData.sessionStartTime = Date.now(), this.options.sessionSecureID = this.sessionData.sessionSecureID, this.stopRecording(), this._firstLoadListeners.stopListening(), this._firstLoadListeners = new I(this.options), yield this.initialize(), n && o && this.identify(n, o);
    });
  }
  _initMembers(e) {
    var o, r, l, d, c, g, h, f, m, R, k;
    this.sessionShortcut = !1, this._recordingStartTime = 0, this._isOnLocalHost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "", this.ready = !1, this.state = "NotRecording", this.manualStopped = !1, this.enableSegmentIntegration = !!e.enableSegmentIntegration, this.privacySetting = (o = e.privacySetting) != null ? o : "default", this.enableCanvasRecording = (r = e.enableCanvasRecording) != null ? r : !1, this.enablePerformanceRecording = (l = e.enablePerformanceRecording) != null ? l : !0, this.inlineImages = (d = e.inlineImages) != null ? d : this._isOnLocalHost, this.inlineVideos = (c = e.inlineVideos) != null ? c : this._isOnLocalHost, this.inlineStylesheet = (g = e.inlineStylesheet) != null ? g : this._isOnLocalHost, this.styleSheetResyncInterval = (h = e.styleSheetResyncInterval) != null ? h : 2e3, this.samplingStrategy = w({
      canvasFactor: 0.5,
      canvasMaxSnapshotDimension: 360,
      canvasClearWebGLBuffer: !0,
      dataUrlOptions: dt()
    }, (f = e.samplingStrategy) != null ? f : {
      canvas: 2
    }), this._backendUrl = (m = e == null ? void 0 : e.backendUrl) != null ? m : "https://pub.highlight.io", this._backendUrl[0] === "/" && (this._backendUrl = new URL(this._backendUrl, document.baseURI).href);
    const t = new bt(`${this._backendUrl}`, {
      headers: {}
    });
    ke(this, $, ht(t, yt())), this.environment = (R = e.environment) != null ? R : "production", this.appVersion = e.appVersion, this.serviceName = (k = e.serviceName) != null ? k : "", typeof e.organizationID == "string" ? this.organizationID = e.organizationID : this.organizationID = e.organizationID.toString(), this.isRunningOnHighlight = this.organizationID === "1" || this.organizationID === "1jdkoe52", this.firstloadVersion = e.firstloadVersion || "unknown", this.sessionShortcut = e.sessionShortcut || !1, this._onToggleFeedbackFormVisibility = () => {
    };
    const L = e, { firstloadVersion: s } = L, n = j(L, ["firstloadVersion"]);
    this._optionsInternal = n, this.listeners = [], this.events = [], this.hasSessionUnloaded = !1, this.hasPushedData = !1, window.Intercom && window.Intercom("onShow", () => {
      window.Intercom("update", {
        highlightSessionURL: this.getCurrentSessionURLWithTimestamp()
      }), this.addProperties({ event: "Intercom onShow" });
    }), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime(), this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime();
  }
  identify(e, t = {}, s) {
    if (!e || e === "") {
      console.warn(
        "Highlight's identify() call was passed an empty identifier.",
        { user_identifier: e, user_object: t }
      );
      return;
    }
    this.sessionData.userIdentifier = e.toString(), this.sessionData.userObject = t, Y(
      E.USER_IDENTIFIER,
      e.toString()
    ), Y(E.USER_OBJECT, JSON.stringify(t)), this._worker.postMessage({
      message: {
        type: C.Identify,
        userIdentifier: e,
        userObject: t,
        source: s
      }
    });
    for (const n of this._integrations)
      n.identify(
        this.sessionData.sessionSecureID,
        e,
        t,
        s
      );
  }
  log(e, t, s) {
    this._firstLoadListeners.messages.push(
      Ht(t, Me, e, s)
    );
  }
  pushCustomError(e, t) {
    return this.consumeCustomError(new Error(e), void 0, t);
  }
  consumeCustomError(e, t, s) {
    let n = {};
    if (s)
      try {
        n = w(w({}, JSON.parse(s)), n);
      } catch (o) {
      }
    return this.consumeError(e, {
      message: t,
      payload: n
    });
  }
  consumeError(e, {
    message: t,
    payload: s,
    source: n,
    type: o
  }) {
    var c, g, h, f;
    e.cause && (s = y(w({}, s), { "exception.cause": e.cause }));
    let r = t ? t + ":" + e.message : e.message;
    o === "React.ErrorBoundary" && (r = "ErrorBoundary: " + r);
    const l = Ut(e), d = {
      event: r,
      type: o != null ? o : "custom",
      url: window.location.href,
      source: n != null ? n : "",
      lineNumber: (c = l[0]) != null && c.lineNumber ? (g = l[0]) == null ? void 0 : g.lineNumber : 0,
      columnNumber: (h = l[0]) != null && h.columnNumber ? (f = l[0]) == null ? void 0 : f.columnNumber : 0,
      stackTrace: l,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      payload: JSON.stringify(s),
      id: Fe()
    };
    this._firstLoadListeners.errors.push(d);
    for (const m of this._integrations)
      m.error(this.sessionData.sessionSecureID, d);
  }
  addProperties(e = {}, t) {
    const s = w({}, e);
    Object.entries(s).forEach(([n, o]) => {
      try {
        structuredClone(o);
      } catch (r) {
        delete s[n];
      }
    }), this._worker.postMessage({
      message: {
        type: C.Properties,
        propertiesObject: s,
        propertyType: t
      }
    });
    for (const n of this._integrations)
      n.track(this.sessionData.sessionSecureID, w({
        sessionSecureID: this.sessionData.sessionSecureID,
        propertyType: t
      }, e));
  }
  initialize(e) {
    return _(this, null, function* () {
      var t, s, n, o, r, l, d, c, g, h, f, m, R, k, L, S, ie, ne, re, oe, ae, ce, le, de, he;
      if (navigator != null && navigator.webdriver && !window.Cypress || (t = navigator == null ? void 0 : navigator.userAgent) != null && t.includes("Googlebot") || (s = navigator == null ? void 0 : navigator.userAgent) != null && s.includes("AdsBot")) {
        (n = this._firstLoadListeners) == null || n.stopListening();
        return;
      }
      try {
        if (e != null && e.forceNew) {
          yield this._reset(e);
          return;
        }
        if (e != null && e.sessionKey && (e == null ? void 0 : e.sessionKey) !== this.sessionData.sessionKey) {
          yield this._reset(y(w({}, e), { forceNew: !0 }));
          return;
        }
        const P = new zt();
        Wt(
          {
            backendUrl: (r = (o = this.options) == null ? void 0 : o.backendUrl) != null ? r : "https://pub.highlight.io",
            otlpEndpoint: (d = (l = this.options) == null ? void 0 : l.otlpEndpoint) != null ? d : "https://otel.highlight.io",
            projectId: (c = this.options) == null ? void 0 : c.organizationID,
            sessionSecureId: (g = this.options) == null ? void 0 : g.sessionSecureID,
            environment: (f = (h = this.options) == null ? void 0 : h.environment) != null ? f : "production",
            networkRecordingOptions: typeof ((m = this.options) == null ? void 0 : m.networkRecording) == "object" ? this.options.networkRecording : void 0,
            tracingOrigins: (R = this.options) == null ? void 0 : R.tracingOrigins,
            serviceName: (L = (k = this.options) == null ? void 0 : k.serviceName) != null ? L : "highlight-browser",
            instrumentations: (ie = (S = this.options) == null ? void 0 : S.otel) == null ? void 0 : ie.instrumentations,
            getIntegrations: () => [...this._integrations],
            productAnalyticsEvents: this._productAnalyticsEvents()
          },
          P
        ), this._gauges.clear(), this._counters.clear(), this._histograms.clear(), this._up_down_counters.clear(), this.logger.log(
          "Initializing...",
          e,
          this.sessionData,
          this.options
        ), this.sessionData = (ne = F(this.sessionData.sessionSecureID)) != null ? ne : this.sessionData, (re = this.sessionData) != null && re.sessionStartTime ? this._recordingStartTime = (oe = this.sessionData) == null ? void 0 : oe.sessionStartTime : (this._recordingStartTime = (/* @__PURE__ */ new Date()).getTime(), this.sessionData.sessionStartTime = this._recordingStartTime), X(""), W(this.sessionData);
        let H = Q(Ce.CLIENT_ID);
        H || (H = O(), Y(Ce.CLIENT_ID, H));
        let U;
        this.options.disableSessionRecording || this.options.disableNetworkRecording !== void 0 || typeof this.options.networkRecording == "boolean" ? U = !1 : U = ((ae = this.options.networkRecording) == null ? void 0 : ae.recordHeadersAndBody) || !1;
        let ge = [];
        if (typeof this.options.networkRecording == "object" && ((ce = this.options.networkRecording.destinationDomains) != null && ce.length) && (ge = this.options.networkRecording.destinationDomains), this._isCrossOriginIframe)
          yield this._setupCrossOriginIframe();
        else {
          const v = yield ye(this, $).initializeSession({
            organization_verbose_id: this.organizationID,
            enable_strict_privacy: this.privacySetting === "strict",
            privacy_setting: this.privacySetting,
            enable_recording_network_contents: U,
            clientVersion: this.firstloadVersion,
            firstloadVersion: this.firstloadVersion,
            clientConfig: JSON.stringify(this._optionsInternal),
            environment: this.environment,
            id: H,
            appVersion: this.appVersion,
            serviceName: this.serviceName,
            session_secure_id: this.sessionData.sessionSecureID,
            session_key: this.sessionData.sessionKey,
            client_id: H,
            network_recording_domains: ge,
            disable_session_recording: this.options.disableSessionRecording
          });
          if (v.initializeSession.secure_id !== this.sessionData.sessionSecureID && this.logger.log(
            `Unexpected secure id returned by initializeSession: ${v.initializeSession.secure_id}, expected ${this.sessionData.sessionSecureID}`
          ), this.sessionData.sessionSecureID = v.initializeSession.secure_id, this.sessionData.projectID = parseInt(
            ((le = v == null ? void 0 : v.initializeSession) == null ? void 0 : le.project_id) || "0"
          ), P.setConfig(v.initializeSession.sampling), !this.sessionData.projectID || !this.sessionData.sessionSecureID) {
            T(
              "error",
              "Failed to initialize Highlight; an error occurred on our end.",
              this.sessionData
            );
            return;
          }
        }
        this.logger.log(
          `Loaded Highlight
Remote: ${this._backendUrl}
Project ID: ${this.sessionData.projectID}
SessionSecureID: ${this.sessionData.sessionSecureID}`
        ), this.options.sessionSecureID = this.sessionData.sessionSecureID, this._worker.postMessage({
          message: {
            type: C.Initialize,
            sessionSecureID: this.sessionData.sessionSecureID,
            backend: this._backendUrl,
            debug: !!this.debugOptions.clientInteractions,
            recordingStartTime: this._recordingStartTime
          }
        });
        for (const v of this._integrations)
          v.init(this.sessionData.sessionSecureID);
        if (this.sessionData.userIdentifier && this.identify(
          this.sessionData.userIdentifier,
          this.sessionData.userObject
        ), this._firstLoadListeners.isListening() ? this._firstLoadListeners.hasNetworkRecording || I.setupNetworkListener(
          this._firstLoadListeners,
          this.options
        ) : this._firstLoadListeners.startListening(), this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this._isCrossOriginIframe || (this.pushPayloadTimerId = setTimeout(() => {
          this._save();
        }, Ie)), this.options.disableSessionRecording) {
          this.logger.log(
            "Highlight is NOT RECORDING a session replay per H.init setting."
          ), this.ready = !0, this.state = "Recording", this.manualStopped = !1;
          return;
        }
        const { getDeviceDetails: ue } = Vt();
        ue && this.recordGauge({
          name: N.DeviceMemory,
          value: ue().deviceMemory,
          category: D.Device,
          group: window.location.href
        });
        const fe = (v, qe) => {
          qe && this.logger.log("received isCheckout emit", { event: v }), this.events.push(v);
        };
        fe.bind(this);
        const xe = !!this._recordStop;
        this._recordStop && (this._recordStop(), this._recordStop = void 0);
        const [Ae, Ke] = at(
          this.privacySetting,
          this.options.maskAllInputs,
          this.options.maskInputOptions
        );
        this._recordStop = J({
          ignoreClass: (de = this.options.ignoreClass) != null ? de : "highlight-ignore",
          ignoreSelector: this.options.ignoreSelector,
          blockClass: (he = this.options.blockClass) != null ? he : "highlight-block",
          blockSelector: this.options.blockSelector,
          emit: fe,
          recordCrossOriginIframes: this.options.recordCrossOriginIframe,
          privacySetting: ot(
            this.privacySetting,
            this.options.maskPiiText
          ),
          maskAllInputs: Ae,
          maskInputOptions: Ke,
          maskTextClass: this.options.maskTextClass,
          maskTextSelector: this.options.maskTextSelector,
          recordCanvas: this.enableCanvasRecording,
          sampling: {
            canvas: {
              fps: this.samplingStrategy.canvas,
              fpsManual: this.samplingStrategy.canvasManualSnapshot,
              resizeFactor: this.samplingStrategy.canvasFactor,
              clearWebGLBuffer: this.samplingStrategy.canvasClearWebGLBuffer,
              initialSnapshotDelay: this.samplingStrategy.canvasInitialSnapshotDelay,
              dataURLOptions: this.samplingStrategy.dataUrlOptions,
              maxSnapshotDimension: this.samplingStrategy.canvasMaxSnapshotDimension
            }
          },
          keepIframeSrcFn: (v) => !this.options.recordCrossOriginIframe,
          inlineImages: this.inlineImages,
          inlineVideos: this.inlineVideos,
          collectFonts: this.inlineImages,
          inlineStylesheet: this.inlineStylesheet,
          styleSheetResyncInterval: this.styleSheetResyncInterval,
          plugins: [rt()],
          logger: typeof this.options.debug == "boolean" && this.options.debug || typeof this.options.debug == "object" && this.options.debug.domRecording ? {
            debug: this.logger.log,
            warn: z
          } : void 0
        }), xe || this.options.recordCrossOriginIframe && this._setupCrossOriginIframeParent(), document.referrer && (window && document.referrer.includes(window.location.origin) || (this.addCustomEvent("Referrer", document.referrer), this.addProperties(
          { referrer: document.referrer },
          { type: "session" }
        ))), this.sessionData.sessionKey && this.addProperties(
          {
            sessionKey: this.sessionData.sessionKey
          },
          { type: "session" }
        ), this._setupWindowListeners(), this.ready = !0, this.state = "Recording", this.manualStopped = !1;
      } catch (P) {
        this._isOnLocalHost && (T("error", P), z("initializeSession", P));
      }
    });
  }
  _productAnalyticsEvents() {
    var s;
    const e = (s = this.options) == null ? void 0 : s.productAnalytics;
    if (e === !1)
      return {};
    const t = {
      clicks: !0,
      pageViews: !0,
      trackEvents: !0
    };
    if (e === void 0 || e === !0)
      return t;
    for (const n of Object.keys(e))
      e[n] === !1 && (t[n] = !1);
    return t;
  }
  _visibilityHandler(e) {
    return _(this, null, function* () {
      if (this.manualStopped) {
        this.logger.log("Ignoring visibility event due to manual stop.");
        return;
      }
      (/* @__PURE__ */ new Date()).getTime() - this._lastVisibilityChangeTime < gt || (this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime(), this.logger.log(`Detected window ${e ? "hidden" : "visible"}.`), e ? (this.addCustomEvent("TabHidden", !0), this.options.disableBackgroundRecording && this.stopRecording()) : (this.options.disableBackgroundRecording && (yield this.initialize()), this.addCustomEvent("TabHidden", !1)));
    });
  }
  _setupCrossOriginIframe() {
    return _(this, null, function* () {
      this.logger.log("highlight in cross-origin iframe is waiting "), yield new Promise((e) => {
        const t = (s) => {
          if (s.data.highlight === ve) {
            const n = s.data;
            this.logger.log("highlight got window message ", n), this.sessionData.projectID = n.projectID, this.sessionData.sessionSecureID = n.sessionSecureID, window.parent.postMessage(
              {
                highlight: _e
              },
              "*"
            ), window.removeEventListener("message", t), e();
          }
        };
        window.addEventListener("message", t);
      });
    });
  }
  _setupCrossOriginIframeParent() {
    this.logger.log(
      "highlight setting up cross origin iframe parent notification"
    ), setInterval(() => {
      window.document.querySelectorAll("iframe").forEach((e) => {
        var t;
        (t = e.contentWindow) == null || t.postMessage(
          {
            highlight: ve,
            projectID: this.sessionData.projectID,
            sessionSecureID: this.sessionData.sessionSecureID
          },
          "*"
        );
      });
    }, Ie), window.addEventListener("message", (e) => {
      e.data.highlight === _e && this.logger.log(
        "highlight got response from initialized iframe"
      );
    });
  }
  _setupWindowListeners() {
    var s;
    try {
      const n = this;
      this.enableSegmentIntegration && this.listeners.push(
        Ye((r) => {
          if (r.type === "track") {
            const l = {};
            l["segment-event"] = r.event, n.addProperties(l, {
              type: "track",
              source: "segment"
            });
          } else if (r.type === "identify") {
            const l = r.userId.replace(
              /^"(.*)"$/,
              "$1"
            );
            n.identify(
              l,
              r.traits,
              "segment"
            );
          }
        })
      ), this.listeners.push(
        ut((r) => {
          this.reloaded ? (this.addCustomEvent("Reload", r), this.reloaded = !1, n.addProperties(
            { reload: !0 },
            { type: "session" }
          )) : this.addCustomEvent("Navigate", r);
        })
      ), this.listeners.push(
        ft(
          (r) => {
            this.addCustomEvent("Viewport", r), this.submitViewportMetrics(r);
          }
        )
      ), this.listeners.push(
        Xe((r, l) => {
          let d = null, c = null;
          if (l && l.target) {
            const g = l.target;
            d = kt(g), c = g.textContent, c && c.length > 2e3 && (c = c.substring(0, 2e3));
          }
          this.addCustomEvent("Click", {
            clickTarget: r,
            clickTextContent: c,
            clickSelector: d
          });
        })
      ), this.listeners.push(
        Ze((r) => {
          r && this.addCustomEvent("Focus", r);
        })
      ), this.listeners.push(
        Bt((r) => {
          const { name: l, value: d } = r, c = [], g = (h, f) => {
            f && c.push({ name: h, value: f });
          };
          switch (r.name) {
            case "LCP": {
              const h = r.attribution;
              g("web_vital.element", h.element), g(
                "web_vital.attribution.url",
                h.url ? xt(h.url) : void 0
              );
              break;
            }
            case "CLS": {
              const h = r.attribution;
              g("web_vital.element", h.largestShiftTarget), g("web_vital.load_state", h.loadState);
              break;
            }
            case "INP": {
              const h = r.attribution;
              g("web_vital.element", h.eventTarget), g("web_vital.event_type", h.eventType), g("web_vital.load_state", h.loadState);
              break;
            }
            case "FID": {
              const h = r.attribution;
              g("web_vital.element", h.eventTarget), g("web_vital.event_type", h.eventType);
              break;
            }
            case "FCP": {
              const h = r.attribution;
              g("web_vital.load_state", h.loadState);
              break;
            }
          }
          this.recordGauge({
            name: l,
            value: d,
            group: window.location.href,
            category: D.WebVital,
            tags: c.length ? c : void 0
          });
        })
      ), this.listeners.push(
        Mt(
          (r) => {
            const l = [];
            r.saveData !== void 0 && l.push({
              name: "saveData",
              value: r.saveData.toString()
            }), r.effectiveType !== void 0 && l.push({
              name: "effectiveType",
              value: r.effectiveType.toString()
            }), r.type !== void 0 && l.push({
              name: "type",
              value: r.type.toString()
            }), Object.entries(r).forEach(([d, c]) => {
              vt(c) && this.recordGauge({
                name: d,
                value: c,
                category: D.Performance,
                group: window.location.href,
                tags: l
              });
            });
          },
          this._recordingStartTime
        )
      ), this.sessionShortcut && this.listeners.push(
        et(this.sessionShortcut, () => {
          window.open(
            this.getCurrentSessionURLWithTimestamp(),
            "_blank"
          );
        })
      ), this.enablePerformanceRecording && (this.listeners.push(
        Ft((r) => {
          this.addCustomEvent("Performance", K(r)), Object.entries(r).filter(([l]) => l !== "relativeTimestamp").forEach(
            ([l, d]) => d && this.recordGauge({
              name: l,
              value: d,
              category: D.Performance,
              group: window.location.href
            })
          );
        }, this._recordingStartTime)
      ), this.listeners.push(
        $t((r) => {
          this.addCustomEvent("Jank", K(r)), this.recordGauge({
            name: "Jank",
            value: r.jankAmount,
            category: D.WebVital,
            group: r.querySelector
          });
        }, this._recordingStartTime)
      )), this._hasPreviouslyInitialized || ((s = window.electron) != null && s.ipcRenderer ? (window.electron.ipcRenderer.on(
        "highlight.run",
        ({ visible: r }) => {
          this._visibilityHandler(!r);
        }
      ), this.logger.log("Set up Electron highlight.run events.")) : (tt(
        (r) => this._visibilityHandler(r)
      ), this.logger.log("Set up document visibility listener.")), this._hasPreviouslyInitialized = !0);
      const o = () => {
        this.hasSessionUnloaded = !0, this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0);
      };
      window.addEventListener("beforeunload", o), this.listeners.push(
        () => window.removeEventListener("beforeunload", o)
      );
    } catch (n) {
      this._isOnLocalHost && (T("error", n), z("initializeSession _setupWindowListeners", n));
    }
    const e = () => {
      this.addCustomEvent("Page Unload", ""), X(this.sessionData.sessionSecureID), W(this.sessionData);
    };
    if (window.addEventListener("beforeunload", e), this.listeners.push(
      () => window.removeEventListener("beforeunload", e)
    ), navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)) {
      const n = () => {
        this.addCustomEvent("Page Unload", ""), X(this.sessionData.sessionSecureID), W(this.sessionData);
      };
      window.addEventListener("pagehide", n), this.listeners.push(
        () => window.removeEventListener("pagehide", n)
      );
    }
  }
  submitViewportMetrics({
    height: e,
    width: t,
    availHeight: s,
    availWidth: n
  }) {
    this.recordGauge({
      name: N.ViewportHeight,
      value: e,
      category: D.Device,
      group: window.location.href
    }), this.recordGauge({
      name: N.ViewportWidth,
      value: t,
      category: D.Device,
      group: window.location.href
    }), this.recordGauge({
      name: N.ScreenHeight,
      value: s,
      category: D.Device,
      group: window.location.href
    }), this.recordGauge({
      name: N.ScreenWidth,
      value: n,
      category: D.Device,
      group: window.location.href
    }), this.recordGauge({
      name: N.ViewportArea,
      value: e * t,
      category: D.Device,
      group: window.location.href
    });
  }
  recordGauge(e) {
    var s, n;
    let t = this._gauges.get(e.name);
    if (!t) {
      if (t = (s = x()) == null ? void 0 : s.createGauge(
        e.name,
        A(e.name, e.unit)
      ), !t) return;
      this._gauges.set(e.name, t);
    }
    t.record(e.value, y(w({}, (n = e.tags) == null ? void 0 : n.reduce((o, r) => y(w({}, o), { [r.name]: r.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
    for (const o of this._integrations)
      o.recordGauge(this.sessionData.sessionSecureID, e);
  }
  recordCount(e) {
    var s, n;
    let t = this._counters.get(e.name);
    if (!t) {
      if (t = (s = x()) == null ? void 0 : s.createCounter(
        e.name,
        A(e.name, e.unit)
      ), !t) return;
      this._counters.set(e.name, t);
    }
    t.add(e.value, y(w({}, (n = e.tags) == null ? void 0 : n.reduce((o, r) => y(w({}, o), { [r.name]: r.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
  }
  recordIncr(e) {
    this.recordCount(y(w({}, e), { value: 1 }));
  }
  recordHistogram(e) {
    var s, n;
    let t = this._histograms.get(e.name);
    if (!t) {
      if (t = (s = x()) == null ? void 0 : s.createHistogram(
        e.name,
        A(e.name, e.unit)
      ), !t) return;
      this._histograms.set(e.name, t);
    }
    t.record(e.value, y(w({}, (n = e.tags) == null ? void 0 : n.reduce((o, r) => y(w({}, o), { [r.name]: r.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
  }
  recordUpDownCounter(e) {
    var s, n;
    let t = this._up_down_counters.get(e.name);
    if (!t) {
      if (t = (s = x()) == null ? void 0 : s.createUpDownCounter(
        e.name,
        A(e.name, e.unit)
      ), !t) return;
      this._up_down_counters.set(e.name, t);
    }
    t.add(e.value, y(w({}, (n = e.tags) == null ? void 0 : n.reduce((o, r) => y(w({}, o), { [r.name]: r.value }), {})), {
      group: e.group,
      category: e.category,
      "highlight.session_id": this.sessionData.sessionSecureID
    }));
  }
  /**
   * Stops Highlight from recording.
   * @param manual The end user requested to stop recording.
   */
  stopRecording(e) {
    this.manualStopped = !!e, this.manualStopped && this.addCustomEvent(
      "Stop",
      "H.stop() was called which stops Highlight from recording."
    ), this.state = "NotRecording", e && this._recordStop && (this._recordStop(), this._recordStop = void 0), this.listeners.forEach((t) => t()), this.listeners = [], Be();
  }
  getCurrentSessionTimestamp() {
    return this._recordingStartTime;
  }
  /**
   * Returns the current timestamp for the current session.
   */
  getCurrentSessionURLWithTimestamp() {
    const e = (/* @__PURE__ */ new Date()).getTime(), { projectID: t, sessionSecureID: s } = this.sessionData, n = (e - this._recordingStartTime) / 1e3;
    return `https://${Z}/${t}/sessions/${s}?ts=${n}`;
  }
  getCurrentSessionURL() {
    const e = this.sessionData.projectID, t = this.sessionData.sessionSecureID;
    return e && t ? `https://${Z}/${e}/sessions/${t}` : null;
  }
  snapshot(e) {
    return _(this, null, function* () {
      yield J.snapshotCanvas(e);
    });
  }
  addSessionFeedback({
    timestamp: e,
    verbatim: t,
    user_email: s,
    user_name: n
  }) {
    var o;
    this._worker.postMessage({
      message: {
        type: C.Feedback,
        verbatim: t,
        timestamp: e,
        userName: n || this.sessionData.userIdentifier,
        userEmail: s || ((o = this.sessionData.userObject) == null ? void 0 : o.name)
      }
    });
  }
  // Reset the events array and push to a backend.
  _save() {
    return _(this, null, function* () {
      var e;
      try {
        this.state === "Recording" && this.listeners && !this.sessionData.sessionKey && this.sessionData.sessionStartTime && Date.now() - this.sessionData.sessionStartTime > mt && (this.logger.log("Resetting session", {
          start: this.sessionData.sessionStartTime
        }), yield this._reset({}));
        let t;
        ((e = this.options) == null ? void 0 : e.sendMode) === "local" && (t = (s) => _(this, null, function* () {
          let n = new Blob(
            [
              JSON.stringify({
                query: wt(_t),
                variables: s
              })
            ],
            {
              type: "application/json"
            }
          );
          return yield window.fetch(`${this._backendUrl}`, {
            method: "POST",
            body: n
          }), 0;
        })), yield this._sendPayload({ sendFn: t }), this.hasPushedData = !0, this.sessionData.lastPushTime = Date.now(), W(this.sessionData);
      } catch (t) {
        this._isOnLocalHost && (T("error", t), z("_save", t));
      }
      this.state === "Recording" && (this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this.pushPayloadTimerId = setTimeout(() => {
        this._save();
      }, pt));
    });
  }
  /**
   * This proxy should be used instead of rrweb's native addCustomEvent.
   * The proxy makes sure recording has started before emitting a custom event.
   */
  addCustomEvent(e, t) {
    if (this.state === "NotRecording") {
      let s;
      const n = () => {
        clearInterval(s), this.state === "Recording" && this.events.length > 0 ? Re(e, t) : s = setTimeout(n, 500);
      };
      s = setTimeout(n, 500);
    } else this.state === "Recording" && (this.events.length > 0 || this.hasPushedData) && Re(e, t);
  }
  _sendPayload(t) {
    return _(this, arguments, function* ({
      sendFn: e
    }) {
      const s = I.getRecordedNetworkResources(
        this._firstLoadListeners,
        this._recordingStartTime
      ), n = I.getRecordedWebSocketEvents(
        this._firstLoadListeners
      ), o = [...this.events], r = [...this._firstLoadListeners.messages], l = [...this._firstLoadListeners.errors], { bytes: d, time: c } = this.enableCanvasRecording ? Le.canvas : Le.normal;
      this._eventBytesSinceSnapshot >= d && (/* @__PURE__ */ new Date()).getTime() - this._lastSnapshotTime >= c && this.takeFullSnapshot(), this.logger.log(
        `Sending: ${o.length} events, ${r.length} messages, ${s.length} network resources, ${l.length} errors 
To: ${this._backendUrl}
Org: ${this.organizationID}
SessionSecureID: ${this.sessionData.sessionSecureID}`
      );
      const g = (/* @__PURE__ */ new Date()).getTime(), h = st();
      if (e) {
        const f = {
          session_secure_id: this.sessionData.sessionSecureID,
          payload_id: g.toString(),
          events: { events: o },
          messages: K({ messages: r }),
          resources: JSON.stringify({ resources: s }),
          web_socket_events: JSON.stringify({ webSocketEvents: n }),
          errors: l,
          is_beacon: !1,
          has_session_unloaded: this.hasSessionUnloaded,
          highlight_logs: h || void 0
        }, { compressedBase64: m } = yield it(f);
        yield e({
          session_secure_id: this.sessionData.sessionSecureID,
          payload_id: (/* @__PURE__ */ new Date()).getTime().toString(),
          data: m
        });
      } else
        this._worker.postMessage({
          message: {
            type: C.AsyncEvents,
            id: g,
            events: o,
            messages: r,
            errors: l,
            resourcesString: JSON.stringify({ resources: s }),
            webSocketEventsString: JSON.stringify({
              webSocketEvents: n
            }),
            hasSessionUnloaded: this.hasSessionUnloaded,
            highlightLogs: h
          }
        });
      W(this.sessionData), I.clearRecordedNetworkResources(
        this._firstLoadListeners
      ), this.events = this.events.slice(o.length), this._firstLoadListeners.messages = this._firstLoadListeners.messages.slice(r.length), this._firstLoadListeners.errors = this._firstLoadListeners.errors.slice(
        l.length
      ), nt(h);
    });
  }
  takeFullSnapshot() {
    if (!this._recordStop) {
      this.logger.log("skipping full snapshot as rrweb is not running");
      return;
    }
    this.logger.log("taking full snapshot", {
      bytesSinceSnapshot: this._eventBytesSinceSnapshot,
      lastSnapshotTime: this._lastSnapshotTime
    }), J.takeFullSnapshot(), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime();
  }
  registerLD(e) {
    this._integrations.length || this._integrations.push(new We(e));
  }
};
$ = new WeakMap();
let ee = se;
const Jt = () => {
  var i, e;
  typeof chrome != "undefined" && ((i = chrome == null ? void 0 : chrome.runtime) != null && i.onMessage) && ((e = chrome == null ? void 0 : chrome.runtime) == null || e.onMessage.addListener(
    (t, s, n) => {
      const o = t.action;
      switch (console.log(
        `[highlight] received '${o}' event from extension.`
      ), o) {
        case "init": {
          p.init(1, {
            debug: !0
          }), p.getSessionURL().then((r) => {
            n({ url: r });
          });
          break;
        }
        case "stop": {
          p.stop(), n({ success: !0 });
          break;
        }
      }
      return !0;
    }
  ));
};
function ns(i) {
  var e;
  i.on && ((e = i.webContents) != null && e.send) && (i.on("focus", () => {
    i.webContents.send("highlight.run", { visible: !0 });
  }), i.on("blur", () => {
    i.webContents.send("highlight.run", { visible: !1 });
  }), i.on("close", () => {
    i.webContents.send("highlight.run", { visible: !1 });
  }));
}
const rs = ({
  next: i,
  payload: e
}) => {
  if (typeof window != "undefined" && typeof document != "undefined" && "H" in window) {
    if (e.obj.type === "track") {
      const t = e.obj.event, s = e.obj.properties;
      window.H.track(t, s);
    } else if (e.obj.type === "identify") {
      const t = e.obj.userId;
      if (t != null && t.length) {
        const s = e.obj.traits;
        window.H.identify(t, s);
      }
    }
  }
  i(e);
}, $e = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightFetchPatch != "undefined")
      return;
    window._originalFetch = window.fetch, window._fetchProxy = (i, e) => window._originalFetch(i, e), window._highlightFetchPatch = (i, e) => window._fetchProxy.call(window || global, i, e), window.fetch = window._highlightFetchPatch;
  }
}, He = () => null, Ve = () => {
  if (typeof window != "undefined") {
    if (typeof window._highlightWebSocketRequestCallback != "undefined")
      return;
    window._highlightWebSocketRequestCallback = He, window._highlightWebSocketEventCallback = He;
    const i = new Proxy(window.WebSocket, {
      construct(e, t) {
        const [, s] = At(), n = new e(...t), o = (g) => {
          window._highlightWebSocketRequestCallback({
            socketId: s,
            initiatorType: "websocket",
            type: "open",
            name: n.url,
            startTimeAbs: performance.timeOrigin + g.timeStamp
          });
        }, r = (g) => {
          window._highlightWebSocketRequestCallback({
            socketId: s,
            initiatorType: "websocket",
            type: "close",
            name: n.url,
            responseEndAbs: performance.timeOrigin + g.timeStamp
          }), n.removeEventListener("open", o), n.removeEventListener("error", d), n.removeEventListener("message", l), n.removeEventListener("close", r);
        }, l = (g) => {
          const { data: h } = g, f = typeof h == "string" ? g.data : void 0;
          let m;
          typeof h == "string" ? m = h.length : h instanceof Blob ? m = h.size : m = h.byteLength || 0, window._highlightWebSocketEventCallback({
            socketId: s,
            type: "received",
            name: n.url,
            timeStamp: performance.timeOrigin + g.timeStamp,
            size: m,
            message: f
          });
        }, d = (g) => {
          window._highlightWebSocketEventCallback({
            socketId: s,
            type: "error",
            name: n.url,
            timeStamp: performance.timeOrigin + g.timeStamp,
            size: 0
          });
        };
        n.addEventListener("open", o), n.addEventListener("error", d), n.addEventListener("message", l), n.addEventListener("close", r);
        const c = new Proxy(n.send, {
          apply: function(g, h, f) {
            const m = f[0], R = typeof m == "string" ? m : void 0;
            let k;
            typeof m == "string" ? k = m.length : m instanceof Blob ? k = m.size : k = m.byteLength || 0, window._highlightWebSocketEventCallback({
              socketId: s,
              type: "sent",
              name: n.url,
              timeStamp: performance.timeOrigin + performance.now(),
              size: k,
              message: R
            }), g.apply(h, f);
          }
        });
        return n.send = c, n;
      }
    });
    window.WebSocket = i;
  }
};
var Qt = /* @__PURE__ */ ((i) => (i.Device = "Device", i.WebVital = "WebVital", i.Frontend = "Frontend", i.Backend = "Backend", i))(Qt || {});
const b = (i, e) => {
  T("warn", `highlight.run warning: (${i}): `, e);
}, Yt = 200;
let B = [], q, u, M, Ue = [], te = !1;
const p = {
  options: void 0,
  init: (i, e) => {
    var t, s, n, o, r, l, d, c;
    try {
      if (p.options = e, typeof window == "undefined" || typeof document == "undefined")
        return;
      if (!i) {
        console.info(
          "Highlight is not initializing because projectID was passed undefined."
        );
        return;
      }
      e != null && e.sessionCookie ? Dt() : ze(!1);
      const g = F();
      let h = O();
      if (e != null && e.sessionKey ? h = O(
        `${i}-${e.sessionKey}`
      ) : g != null && g.sessionSecureID && (h = g.sessionSecureID), te)
        return { sessionSecureID: h };
      te = !0, $e(), Ve();
      const f = y(w({}, e), {
        organizationID: i,
        firstloadVersion: It,
        environment: (e == null ? void 0 : e.environment) || "production",
        appVersion: e == null ? void 0 : e.version,
        sessionSecureID: h
      });
      return M = new I(f), e != null && e.manualStart || M.startListening(), u = u != null ? u : new ee(f, M), e != null && e.manualStart || u.initialize(), !((s = (t = e == null ? void 0 : e.integrations) == null ? void 0 : t.mixpanel) != null && s.disabled) && ((o = (n = e == null ? void 0 : e.integrations) == null ? void 0 : n.mixpanel) != null && o.projectToken) && ct(e.integrations.mixpanel), !((l = (r = e == null ? void 0 : e.integrations) == null ? void 0 : r.amplitude) != null && l.disabled) && ((c = (d = e == null ? void 0 : e.integrations) == null ? void 0 : d.amplitude) != null && c.apiKey) && lt(e.integrations.amplitude), { sessionSecureID: h };
    } catch (g) {
      b("init", g);
    }
  },
  snapshot: (i) => _(void 0, null, function* () {
    try {
      if (u && u.ready)
        return yield u.snapshot(i);
    } catch (e) {
      b("snapshot", e);
    }
  }),
  addSessionFeedback: ({
    verbatim: i,
    userName: e,
    userEmail: t,
    timestampOverride: s
  }) => {
    try {
      p.onHighlightReady(
        () => u.addSessionFeedback({
          verbatim: i,
          timestamp: s || (/* @__PURE__ */ new Date()).toISOString(),
          user_email: t,
          user_name: e
        })
      );
    } catch (n) {
      b("error", n);
    }
  },
  consumeError: (i, e, t) => {
    try {
      p.onHighlightReady(
        () => u.consumeCustomError(
          i,
          e,
          JSON.stringify(t)
        )
      );
    } catch (s) {
      b("error", s);
    }
  },
  consume: (i, e) => {
    try {
      p.onHighlightReady(() => u.consumeError(i, e));
    } catch (t) {
      b("error", t);
    }
  },
  error: (i, e) => {
    try {
      p.onHighlightReady(
        () => u.pushCustomError(i, JSON.stringify(e))
      );
    } catch (t) {
      b("error", t);
    }
  },
  track: (i, e = {}) => {
    var t, s, n, o, r, l, d, c, g, h, f;
    try {
      p.onHighlightReady(() => {
        u.addProperties(y(w({}, e), { event: i })), u.log("H.track", "INFO", y(w({}, e != null ? e : {}), {
          event: i
        }));
      });
      const m = u == null ? void 0 : u.getCurrentSessionURL();
      (n = (s = (t = p.options) == null ? void 0 : t.integrations) == null ? void 0 : s.mixpanel) != null && n.disabled || (o = window.mixpanel) != null && o.track && window.mixpanel.track(i, y(w({}, e), {
        highlightSessionURL: m
      })), (d = (l = (r = p.options) == null ? void 0 : r.integrations) == null ? void 0 : l.amplitude) != null && d.disabled || (c = window.amplitude) != null && c.getInstance && window.amplitude.getInstance().logEvent(i, y(w({}, e), {
        highlightSessionURL: m
      })), (f = (h = (g = p.options) == null ? void 0 : g.integrations) == null ? void 0 : h.intercom) != null && f.disabled || window.Intercom && window.Intercom("trackEvent", i, e);
    } catch (m) {
      b("track", m);
    }
  },
  log: (i, e, t) => {
    try {
      p.onHighlightReady(
        () => u.log(i, e, t != null ? t : {})
      );
    } catch (s) {
      b("log", s);
    }
  },
  start: (i) => {
    var e;
    (u == null ? void 0 : u.state) === "Recording" && !(i != null && i.forceNew) ? i != null && i.silent || console.warn(
      "Highlight is already recording. Please `H.stop()` the current session before starting a new one."
    ) : (((e = u == null ? void 0 : u._firstLoadListeners) != null ? e : M).startListening(), p.onHighlightReady(
      () => _(void 0, null, function* () {
        yield u.initialize(i);
      }),
      { waitForReady: !1 }
    ));
  },
  stop: (i) => {
    (u == null ? void 0 : u.state) !== "Recording" ? i != null && i.silent || console.warn(
      "Highlight is already stopped. Please call `H.start()`."
    ) : p.onHighlightReady(() => u.stopRecording(!0));
  },
  identify: (i, e = {}, t) => {
    var s, n, o, r, l, d, c, g;
    try {
      p.onHighlightReady(
        () => u.identify(i, e, t)
      );
    } catch (h) {
      b("identify", h);
    }
    if ((o = (n = (s = p.options) == null ? void 0 : s.integrations) == null ? void 0 : n.mixpanel) != null && o.disabled || (r = window.mixpanel) != null && r.identify && (window.mixpanel.identify(
      typeof (e == null ? void 0 : e.email) == "string" ? e == null ? void 0 : e.email : i
    ), e && (window.mixpanel.track("identify", e), window.mixpanel.people.set(e))), !((c = (d = (l = p.options) == null ? void 0 : l.integrations) == null ? void 0 : d.amplitude) != null && c.disabled) && (g = window.amplitude) != null && g.getInstance && (window.amplitude.getInstance().setUserId(i), Object.keys(e).length > 0)) {
      const h = Object.keys(
        e
      ).reduce((f, m) => (f.set(m, e[m]), f), new window.amplitude.Identify());
      window.amplitude.getInstance().identify(h);
    }
  },
  metrics: (i) => {
    try {
      for (const e of i)
        p.recordMetric(e);
    } catch (e) {
      b("metrics", e);
    }
  },
  recordMetric: (i) => {
    try {
      p.onHighlightReady(() => {
        var e;
        u.recordGauge(y(w({}, i), {
          tags: (e = i.tags) != null ? e : [],
          group: window.location.href,
          category: "Frontend"
          /* Frontend */
        }));
      });
    } catch (e) {
      b("recordMetric", e);
    }
  },
  recordCount: (i) => {
    try {
      p.onHighlightReady(() => {
        u.recordCount(i);
      });
    } catch (e) {
      b("recordCount", e);
    }
  },
  recordIncr: (i) => {
    try {
      p.onHighlightReady(() => {
        u.recordIncr(i);
      });
    } catch (e) {
      b("recordIncr", e);
    }
  },
  recordHistogram: (i) => {
    try {
      p.onHighlightReady(() => {
        u.recordHistogram(i);
      });
    } catch (e) {
      b("recordHistogram", e);
    }
  },
  recordUpDownCounter: (i) => {
    try {
      p.onHighlightReady(() => {
        u.recordUpDownCounter(i);
      });
    } catch (e) {
      b("recordUpDownCounter", e);
    }
  },
  startSpan: (i, e, t, s) => {
    const n = Te();
    if (!n) {
      const r = Pe();
      return s === void 0 && t === void 0 ? e(r) : s === void 0 ? t(r) : s(r);
    }
    const o = (r, l) => {
      const d = l(r);
      return d instanceof Promise ? d.finally(() => r.end()) : (r.end(), d);
    };
    return s === void 0 && t === void 0 ? n.startActiveSpan(
      i,
      (r) => o(r, e)
    ) : s === void 0 ? n.startActiveSpan(
      i,
      e,
      (r) => o(r, t)
    ) : n.startActiveSpan(
      i,
      e,
      t,
      (r) => o(r, s)
    );
  },
  startManualSpan: (i, e, t, s) => {
    const n = Te();
    if (!n) {
      const o = Pe();
      return s === void 0 && t === void 0 ? e(o) : s === void 0 ? t(o) : s(o);
    }
    return s === void 0 && t === void 0 ? n.startActiveSpan(i, e) : s === void 0 ? n.startActiveSpan(
      i,
      e,
      t
    ) : n.startActiveSpan(
      i,
      e,
      t,
      s
    );
  },
  getSessionURL: () => new Promise((i, e) => {
    p.onHighlightReady(() => {
      const t = u.sessionData.sessionSecureID, s = F(t);
      s ? i(
        `https://${Z}/${s.projectID}/sessions/${t}`
      ) : e(new Error(`Unable to get session URL: ${t}`));
    });
  }),
  getSessionDetails: () => new Promise((i, e) => {
    p.onHighlightReady(() => _(void 0, null, function* () {
      try {
        const t = yield p.getSessionURL();
        if (!t)
          throw new Error("Could not get session URL");
        const s = u.sessionData.sessionSecureID, n = F(s), o = n == null ? void 0 : n.sessionStartTime;
        if (!o)
          throw new Error("Could not get session start timestamp");
        const r = (/* @__PURE__ */ new Date()).getTime(), l = new URL(t), d = new URL(t);
        d.searchParams.set(
          "ts",
          ((r - o) / 1e3).toString()
        ), i({
          url: l.toString(),
          urlWithTimestamp: d.toString(),
          sessionSecureID: s
        });
      } catch (t) {
        e(t);
      }
    }));
  }),
  getRecordingState: () => {
    var i;
    return (i = u == null ? void 0 : u.state) != null ? i : "NotRecording";
  },
  onHighlightReady: (i, e) => {
    if (u && u.ready) {
      i();
      return;
    }
    if (B.push({ options: e, func: i }), q !== void 0)
      return;
    const t = () => {
      B = B.filter((n) => {
        var o;
        return !u || ((o = n.options) == null ? void 0 : o.waitForReady) !== !1 && !u.ready ? !0 : (n.func(), !1);
      }), q = void 0, B.length > 0 && (q = setTimeout(
        t,
        Yt
      ));
    };
    t();
  },
  registerLD(i) {
    Ue.length || (p.onHighlightReady(() => {
      u.registerLD(i);
    }), Rt(this, i, p.options), Ue.push(new We(i)));
  }
};
typeof window != "undefined" && (window.H = p);
Jt();
$e();
Ve();
const os = {
  reset: () => {
    te = !1, u = void 0, B = [], q = void 0, M = void 0;
  },
  setHighlightObj: (i) => {
    u = i;
  }
};
export {
  O as GenerateSecureID,
  p as H,
  rs as HighlightSegmentMiddleware,
  us as LDObserve,
  ms as LDRecord,
  Qt as MetricCategory,
  hs as Observe,
  ls as Record,
  os as __testing,
  ns as configureElectronHighlight
};
//# sourceMappingURL=index.js.map
